import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import useView from '@databases/views/useView';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

interface useHasNumberedEntriesProps {
  contentId: string;
}

const useHasNumberedEntries = ({ contentId }: useHasNumberedEntriesProps) => {
  const { view } = useView();
  const isVisualRefreshM1Enabled = isFeatureFlagEnabled(
    'databases-frontend-visual-refresh-table-m1'
  );
  const numberOfEntries = defaultStoreUtils.useEqualSelector((state) => {
    const databaseDraftView = selectDatabaseDraftByContentId(state, {
      contentId,
      viewSettings: view.settings,
      includeDeleted: true,
    });
    return databaseDraftView.entries.length;
  });
  //If visual refresh is disabled, we compute this boolean as we did before
  if (!isVisualRefreshM1Enabled) {
    return view.settings.layout.showNumberedEntries && numberOfEntries !== 0;
  }
  //If visual refresh is enabled, we return true as we are we reusing EntryPrefix for checkboxes
  return true;
};

export default useHasNumberedEntries;
